import React, { useContext, useEffect, useRef } from 'react';
import { View, Animated, Easing, StyleSheet } from 'react-native';
import { DyteUIContext } from '../lib/context-provider/ui-context';

interface SpinnerProps {
  style?: object;
}

export default function DyteSpinner({ style }: SpinnerProps) {
  const rotateAnim = useRef(new Animated.Value(0)).current;

  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  useEffect(() => {
    Animated.loop(
      Animated.timing(rotateAnim, {
        toValue: 1,
        duration: 1000,
        easing: Easing.linear,
        useNativeDriver: true,
      })
    ).start();
  }, [rotateAnim]);

  const rotate = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  });

  const styles = StyleSheet.create({
    container: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    spinner: {
      width: 25,
      height: 25,
      borderWidth: 2,
      borderRadius: 12.5,
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: colors.brand[500],
      borderLeftColor: colors.brand[500], // Only the left and bottom borders are colored blue
    },
  });

  return (
    <View style={[styles.container, style]}>
      <Animated.View style={{ transform: [{ rotate }] }}>
        <View style={styles.spinner} />
      </Animated.View>
    </View>
  );
}
